module.exports = __webpack_public_path__ + "static/media/nodejs.c7718d20.png";